import React from "react";

interface MenuItemProps {
  menu: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  subMenu?: string;
}

const MenuItem: React.FC<MenuItemProps> = ({ menu, icon: Icon, subMenu }) => {
  return (
    <div className="flex items-center">
      <Icon
        className={`icon-svg flex-shrink-0 w-6 h-6 ${
          subMenu === menu
            ? "shrink-0 fill-[#E96012]"
            : "text-gray-500 group-hover:fill-[#E96012] dark:group-hover:fill-white-dark"
        }  dark:group-hover:text-white-dark`}
      />
      <span
        className={`ltr:pl-2 rtl:pr-2 capitalize ${
          subMenu === menu ? "text-[#E96012] dark:text-white" : "text-gray-500 group-hover:text-[#E96012]"
        } dark:text-[#C5C6C9] dark:group-hover:text-white-dark text-wrap text-left`}
      >
        {menu}
      </span>
    </div>
  );
};

export default MenuItem;
